import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const GetSubscriptionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GetSubscriptionProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["subscription"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`subscriptions`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <GetSubscriptionContext.Provider value={contextValue}>
      {children}
    </GetSubscriptionContext.Provider>
  );
};

export default GetSubscriptionProvider;
